<div class="modal-body p-4" style="max-height: 95vh; overflow-y: auto;">
  <div class="row">
    <div id="delivery-note" class="page">
      <div class="container">
        <img src="assets/img/logo/logo_accent.svg" />
        <div class="vyootrip-info">
          <p>VYOOTRIP SOLUTIONS S L</p>
          <p>B23801467</p>
          <p>CALLE EGIDO, 2</p>
          <p>LOS VILLARES, JAÉN (23160), JAÉN, España</p>
        </div>
      </div>
      <div class="container company-info">
        <div class="company-row">
          <div class="d-flex flex-column">
            <p class="bold">PROFORMA {{ getDeliveryNotes() }}</p>
            <span *ngIf="transaction?.type === 'refund'" class="text-danger mt-1">({{ 'company.transaction.filters.type-refund' | translate }})</span>
          </div>
          <p>{{ booked[0]?.createdAt | dateMoment : "YYYY-MM-DD HH:mm" : "DD/MM/YYYY HH:mm" }}</p>
        </div>
        <div class="company-row">
          <div class="company-info details" style="gap: 0" *ngIf="company">
            <p class="bold">{{ company.name }}</p>
            <p>{{ company.cif }}</p>
            <p>{{ company.address }}</p>
            <p>{{ company.city }} ({{ company.postalCode }}), {{ company.country }}</p>
          </div>
          <p class="green-text">TOTAL {{getTotalPrice() | price}} €</p>
        </div>
      </div>

      <div *ngFor="let bookedItem of booked" class="booked-data border-bottom mb-3 pb-2">
        <div>
          <p>{{ 'delivery-note.concept' | translate }}</p>
          <p>{{ type | translate }}</p>
          <p *ngIf="bookedItem.from">{{ bookedItem.from }} {{ bookedItem.to ? '- ' + bookedItem.to : '' }}</p>
          <p *ngIf="bookedItem.hotelName">{{ bookedItem.hotelName }}{{ bookedItem.destinationName ? ', ' + bookedItem.destinationName : '' }}</p>
          <p *ngIf="bookedItem.hotel">{{ bookedItem.hotel.name }}{{ bookedItem.hotel.destinationName ? ', ' + bookedItem.hotel.destinationName : '' }}</p>
          <p *ngIf="!bookedItem.hotel && !bookedItem.hotelName && !bookedItem.from">{{ bookedItem.type }}</p>
          <p *ngIf="bookedItem.departDate">{{ bookedItem.departDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY" }} {{ bookedItem.returnDate ? 'a ' + (bookedItem.returnDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY") : '' }}</p>
          <p *ngIf="bookedItem.beginDate">{{ bookedItem.beginDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY" }} {{ bookedItem.endDate ? 'a ' + (bookedItem.endDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY") : '' }}</p>
          <p *ngIf="bookedItem.checkIn">{{ bookedItem.checkIn | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY" }} {{ bookedItem.checkOut ? 'a ' + (bookedItem.checkOut  | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY") : '' }}</p>
          <div *ngIf="getUserForBookedItem(bookedItem).length > 0">
            <p style="font-weight: bold;" *ngFor="let user of getUserForBookedItem(bookedItem)">
              {{ user?.name }} {{ user?.lastname }}
            </p>
          </div>
        </div>
        <div>
          <p>{{ 'delivery-note.price' | translate }}</p>
          <p>{{ ((!bookedItem.freeTaxes && transaction?.type !== 'refund') ? (getUnitPrice(bookedItem) / 1.1) : getUnitPrice(bookedItem)) | price }}</p>
        </div>
        <div>
          <p>{{ 'delivery-note.subtotal' | translate }}</p>
          <p>{{ ((!bookedItem.freeTaxes && transaction?.type !== 'refund') ? (getUnitPrice(bookedItem) / 1.1) : getUnitPrice(bookedItem)) | price }}</p>
        </div>
        <div *ngIf="!bookedItem.freeTaxes && transaction?.type !== 'refund'">
          <p>{{ 'delivery-note.iva' | translate }}</p>
          <p>10%</p>
        </div>
        <div>
          <p>{{ 'delivery-note.total' | translate }}</p>
          <p>{{ getUnitPrice(bookedItem) | price }}</p>
        </div>
      </div>
      <div class="price-info">
        <div>
          <p>{{ 'delivery-note.tax-base' | translate }}</p>
          <p *ngIf="!booked[0].freeTaxes && transaction?.type !== 'refund'">{{ 'delivery-note.iva' | translate }} 10%</p>
          <p>{{ 'delivery-note.total' | translate }}</p>
        </div>
        <div>
          <p>{{ ((!booked[0].freeTaxes && transaction?.type !== 'refund')? (getTotalPrice() / 1.1) : getTotalPrice()) | price }}</p>
          <p *ngIf="!booked[0].freeTaxes && transaction?.type !== 'refund'">{{ (getTotalPrice() / 1.1 * 0.1) | price }}</p>
          <p>{{ getTotalPrice() | price }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="btn-container">
        <button class="custom-btn mb-0 mr-2" (click)="downloadPDFBooked()">
          {{ "common.download" | translate }}
        </button>
        <button class="custom-btn custom-btn--close mb-0" (click)="closeModal()">
          {{ "common.close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
